<template>
  <Chatroom
    v-if="isChatroomLayout"
    :context="context"
    :entity-id="entityId"
    :conversation-id="conversationId"
    :channel-name="channelName"
    :description="description"
    :channel-href="channelHref"
    :has-chat-room-header="hasChatRoomHeader"
    :show-deleted-messages="showDeletedMessages"
    :at-symbol-items="atSymbolItems"
    :loading-at-symbol-items="loadingAtSymbolItems"
    @search:at-symbol="$emit('search:at-symbol', $event)"
    @select:at-symbol="$emit('select:at-symbol', $event)"
  />
  <Comments
    v-else
    :context="context"
    :entity-id="entityId"
    :can-comment="canComment"
    :conversation-id="conversationId"
    :show-deleted-comments="showDeletedMessages"
  />
</template>

<script>

import { mapState } from "pinia";
import { Enum } from "@vcl";
import Comments from "%/components/community/chatrooms/comments/Comments";
import Chatroom from "%/components/community/chatrooms/slack-style/Chatroom";
import { useConversationStore } from "%/stores/conversation-store";

export default {
  name: "Conversation",
  components: {
    Chatroom,
    Comments,
  },
  props: {
    layout: {
      type: Enum,
      required: true,
      options: ["chatroom", "comments"],
    },
    context: {
      type: String,
      required: true,
    },
    entityId: {
      type: Number,
      required: true,
    },
    conversationId: {
      type: Number,
      required: false,
      default: 0,
    },
    channelName: {
      type: String,
      required: false,
      default: "",
    },
    description: {
      type: String,
      required: false,
      default: "",
    },
    channelHref: {
      type: String,
      required: false,
      default: "#",
    },
    hasChatRoomHeader: {
      type: Boolean,
      required: false,
      default: true,
    },
    canComment: {
      type: Boolean,
      required: false,
      default: false,
    },
    canLikeComments: {
      type: Boolean,
      required: false,
      default: false,
    },
    canReplyToComments: {
      type: Boolean,
      required: false,
      default: false,
    },
    canVoteOnComments: {
      type: Boolean,
      required: false,
      default: false,
    },
    showDeletedMessages: {
      type: Boolean,
      required: false,
      default: false,
    },
    loadingAtSymbolItems: {
      type: Boolean,
      required: false,
      default: false,
    },
    atSymbolItems: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["search:at-symbol", "select:at-symbol"],
  computed: {
    ...mapState(useConversationStore, ["conversation"]),
    isChatroomLayout() {
      return this.layout === "chatroom";
    },
  },
};
</script>
